import { Badge, Dropdown } from "react-bootstrap";
import React, { useState } from "react";
import moment from "moment";
import NoteModal from "./Modals/NoteModal";
import { lddGlobalSessionInfo } from "../../navigationTypes";

type CustomToggleProps = {
    children: React.ReactNode;
    onClick: (...arg: any[]) => void;
    faName: string;
    style?: React.CSSProperties;
}

type DocumentRowProps = {
    FileName: string;
    FileType: "Project" | "Unit" | "Buyer";
    Timestamp: string;
    Link: string;
    DocID?: number;
    MsgID?: string;
    SessionInfo: lddGlobalSessionInfo;
    setDeleteModal: ({ }: { show: boolean, dname: string, docID: number, msgID: string }) => void;
    Note?: string;
    Read?: boolean
}

const CustomToggle = React.forwardRef<HTMLInputElement, CustomToggleProps>(
    (props, ref) => (
        <i className={props.faName}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                props.onClick(e);
            }}
            style={(props.style === undefined) ? {} : props.style}>
            {props.children}
        </i>
))

const BuilderDocumentRow = ({
    FileName,
    FileType,
    Timestamp,
    Link,
    DocID,
    MsgID,
    SessionInfo,
    setDeleteModal,
    Note,
    Read
}: DocumentRowProps) => {
    const [showNoteModal, setShowNoteModal] = useState(false);
    function dateStr(timeStr: string): string {
        return moment(timeStr).format('D/MMM/YYYY H:mm:ss').toUpperCase();
    }

    return (<>
        <NoteModal show={showNoteModal} setShow={setShowNoteModal} note={Note} />
        <tr onClick={() => { window.open(process.env.REACT_APP_DSAPI_ENDPOINT + Link + `&SessionID=${SessionInfo?.sid}`) }}>
            <td>
                <i className="fa-solid fa-file-pdf"></i>
            </td>

            <td>{FileName}</td>
            <td>{Read == false && 
                <Badge bg="warning" text="dark" pill>New</Badge>}
            </td>
            {FileType === 'Project' && 
                <td><Badge bg="custom" text="white" pill>{FileType}</Badge></td>
            }
            {FileType === 'Unit' && 
                <td><Badge bg="info" text="dark" pill>{FileType}</Badge></td>
            }
            {FileType === 'Buyer' && <td></td>}
            <td><Badge bg="secondary" text="dark" pill>{dateStr(String(Timestamp))}</Badge></td>
            
            <td className="align-right" onClick={(e) => { e.stopPropagation() }}>
                {Note && Note > "" &&
                    <i className="fa-regular fa-message-lines"
                        onClick={() => setShowNoteModal(true)} 
                        title="Note"
                    />
                }
                <a href={process.env.REACT_APP_DSAPI_ENDPOINT + Link + `&SessionID=${SessionInfo?.sid}`} download={FileName}>
                    <i className="fa-regular fa-arrow-down-to-line"
                        title="Download"
                        style={{marginLeft:'10px'}}>
                    </i>
                </a>
                {
                    FileType === 'Buyer' &&
                        <Dropdown drop='down-centered' className="options" style={{ display: "inline" }}>
                            <Dropdown.Toggle as={CustomToggle} faName="fa-regular fa-ellipsis" style={{marginLeft:'10px'}} />
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => {
                                    setDeleteModal({show: true, dname: FileName, docID: DocID, msgID: MsgID});
                                }}>Delete</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                }
            </td>
        </tr>
        </>
    )
}

export default BuilderDocumentRow;